import { usePagination, useGlobalFilter, useTable } from "react-table"
import { useEffect, useMemo } from "react"
import {Table, Button} from 'react-bootstrap';




const MyTable = (props) => {
    let data = [
        {
            id: 1,
            name: 'usman abubakar',
            occupation: 'Full Stack Software Engineer',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'fatima muhammad',
            occupation: 'UI/UX DESIGNER',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'usman abubakar',
            occupation: 'Full Stack Software Engineer',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'fatima muhammad',
            occupation: 'UI/UX DESIGNER',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'usman abubakar',
            occupation: 'Full Stack Software Engineer',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'fatima muhammad',
            occupation: 'UI/UX DESIGNER',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'usman abubakar',
            occupation: 'Full Stack Software Engineer',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'fatima muhammad',
            occupation: 'UI/UX DESIGNER',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'usman abubakar',
            occupation: 'Full Stack Software Engineer',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'fatima muhammad',
            occupation: 'UI/UX DESIGNER',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'usman abubakar',
            occupation: 'Full Stack Software Engineer',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'fatima muhammad',
            occupation: 'UI/UX DESIGNER',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'usman abubakar',
            occupation: 'Full Stack Software Engineer',
            level: 'Senior'
        },
        {
            id: 1,
            name: 'fatima muhammad',
            occupation: 'UI/UX DESIGNER',
            level: 'Senior'
        }

    ]
    for(let i = 1; i <= data.length; i++){
        data[i-1].sn = i;
    }
    data = useMemo(() => data, []);
    console.log(data);
    const columns = useMemo( () => [
        {
            Header: 'S/N',
            accessor: 'sn'
        },
        {
            Header: 'id',
            accessor: 'id'
        },
        {
            Header: 'name',
            accessor: 'name',
        },
        {
            Header: 'occupation',
            accessor: 'occupation'
        },
        {
            Header: 'level',
            accessor: 'level'
        },
        {
            Header: "Receipt",
            accessor: (row) => 
            <>
            {/* <Button variant="dark" className="form-select"> Action </Button> */}
            <button type="button" className="btn btn-default btn-sm btn-flat border-info wave-effect text-info dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                    Action
                    </button>
                    <div className="dropdown-menu" >
                        <a className="dropdown-item view_user" href="javascript:void(0)" data-id="<?php echo $row['id'] ?>">View</a>
                        <div className="dropdown-divider"></div>
                        <a className="dropdown-item" href="./index.php?page=edit_transaction&id=<?php echo $row['id'] ?>">Edit</a>
                    </div>
                        
            </>
            ,
        }
    ], [])
    const {
        getTabelProps,
        getTableBodyProps,
        headerGroups,
        page,
        pageOptions,
        setPageSize,
        prepareRow,
        setGlobalFilter,
        previousPage, nextPage, canNextPage, canPreviousPage, state
        
    } = useTable(
        {columns, data},
        useGlobalFilter,
        usePagination,
    );


    useEffect(() => {
        setPageSize(10)
       
    }, [])
    return (
        <div className=' row justify-content-center py-5'>
             <h4> <b className=" mb-5 ms-5">{props.page}</b> </h4>
            <div
            className="col-lg-11 col-md-11 col-sm-11 col-xs-11 col-xxs-11 card pb-4 px-3 pt-5"
            > 
           
            <div className="row">
                <div className="col-lg-4 col-md-4 me-auto">
                    <input name="search" type="text" placeHolder="Search..." className="form-control mb-sm-1"
                    onChange={e => {
                        // console.log(e.target.value);
                        setGlobalFilter(e.target.value)
                    }}
                    />
                </div>
                <div className="col-lg-3 col-6 col-md-3">
                    <select 
                    onChange={(e)=> setPageSize(Number(e.target.value))}
                    className="form-select">
                        <option value={10}>Show 10</option>
                        <option value={20}>Show 20</option>
                        <option value={30}>Show 30</option>
                        <option value={40}>Show 40</option>
                    </select>
                </div>
            </div>
            <hr />
            <Table  {... getTabelProps} 
            className=''
            bordered
            variant="outline-dark"
            >
                <thead> 
                    {
                        headerGroups.map(headerGroup => (
                            <tr {... headerGroup.getHeaderGroupProps}>
                                {
                                    headerGroup.headers.map(column => (
                                        <th {...column.getHeaderProps}>
                                            {column.render('Header')}
                                        </th>
                                    ))
                                }
                            </tr>
                        ))
                    }
                </thead>
                <tbody {... getTableBodyProps}>

                    {
                        page.map(row => {
                            prepareRow(row)

                            return (
                                <tr {... row.getRowProps}>
                                    {
                                        row.cells.map(cell => (
                                            <td {...cell.getCellProps}>
                                                {
                                                    cell.render('Cell')
                                                }
                                            </td>
                                        ))
                                    }
                                </tr>
                            )
                        })
                    }
                    
                </tbody>
            </Table>
            <div style={{ marginBottom: '40px' }}>
                <center> 
                <Button disabled={!canPreviousPage}onClick={() => previousPage()} variant='dark' style={{ width: '100px' }} className=''> Previous </Button>
                <span>
                        Page {state.pageIndex.length}
                       <strong> {state.pageIndex + 1} of {pageOptions.length} </strong>
                    </span>
                <Button disabled={!canNextPage} onClick={() => nextPage()} variant='dark' style={{ width: '100px' }} className=''> Next </Button>
                </center>
                </div>
            </div>

        </div>
    )
}

export default MyTable